// 漫画作品数据

export interface MangaItem {
  id: string;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  rating: number;
  ratingCount: number;
  status: string;
  chapters: string;
  cover: string;
  intro: string;
  popular: number;
  updateInfo: string;
}

export const mangaList: MangaItem[] = [
  {
    id: "star-rail",
    title: "星轨之下",
    author: "林默",
    genre: "科幻",
    tags: ["星际", "冒险", "热血"],
    rating: 9.6,
    ratingCount: 12840,
    status: "连载中",
    chapters: "132话",
    cover: "https://readdy.ai/api/search-image?query=A%20vibrant%20anime%20style%20manga%20cover%20of%20a%20young%20star%20pilot%20standing%20before%20a%20glowing%20space%20station%2C%20deep%20orange%20and%20teal%20nebula%20backdrop%2C%20dynamic%20linework%2C%20warm%20cinematic%20lighting%2C%20clean%20simple%20composition%2C%20editorial%20illustration&width=400&height=560&seq=manga-cover-starrail&orientation=portrait",
    intro: "少年星舰驾驶员陈野在废弃轨道上发现了一艘不属于任何文明的幽灵飞船，从此卷入跨越星河的宏大谜团。",
    popular: 1,
    updateInfo: "3天前更新",
  },
  {
    id: "cloud-cafe",
    title: "云端食堂",
    author: "苏小满",
    genre: "美食",
    tags: ["治愈", "美食", "日常"],
    rating: 9.4,
    ratingCount: 9860,
    status: "连载中",
    chapters: "89话",
    cover: "https://readdy.ai/api/search-image?query=A%20warm%20cozy%20anime%20style%20manga%20cover%20of%20a%20chef%20holding%20a%20steaming%20bowl%20of%20noodles%20in%20a%20cloud%20floating%20restaurant%2C%20soft%20cream%20and%20coral%20color%20palette%2C%20gentle%20healing%20atmosphere%2C%20clean%20illustration%20composition&width=400&height=560&seq=manga-cover-cloudcafe&orientation=portrait",
    intro: "开在云端之上的小食堂，用一餐一饭温暖每一个疲惫的旅人。治愈系美食日常，暖心上线。",
    popular: 2,
    updateInfo: "1天前更新",
  },
  {
    id: "spirit-master",
    title: "少年御灵师",
    author: "白泽",
    genre: "玄幻",
    tags: ["御灵", "成长", "战斗"],
    rating: 9.2,
    ratingCount: 15230,
    status: "连载中",
    chapters: "210话",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20anime%20manga%20cover%20of%20a%20boy%20summoner%20with%20a%20glowing%20spirit%20beast%2C%20warm%20orange%20and%20amber%20magic%20energy%2C%20fantasy%20battle%20pose%2C%20bold%20linework%2C%20high%20contrast%20warm%20lighting%2C%20clean%20editorial%20composition&width=400&height=560&seq=manga-cover-spiritmaster&orientation=portrait",
    intro: "灵力衰退的乱世，少年阿离觉醒御灵之力，与上古灵兽签订契约，踏上守护苍生的修行之路。",
    popular: 3,
    updateInfo: "2天前更新",
  },
  {
    id: "mountain-cat",
    title: "山雾里的猫",
    author: "木糖",
    genre: "治愈",
    tags: ["日常", "治愈", "乡村"],
    rating: 9.7,
    ratingCount: 7320,
    status: "已完结",
    chapters: "56话",
    cover: "https://readdy.ai/api/search-image?query=A%20soft%20anime%20manga%20cover%20of%20a%20white%20cat%20resting%20on%20a%20sunlit%20wooden%20porch%20in%20a%20misty%20mountain%20village%2C%20warm%20pastel%20cream%20and%20peach%20tones%2C%20peaceful%20cozy%20atmosphere%2C%20gentle%20lighting%2C%20clean%20healing%20illustration&width=400&height=560&seq=manga-cover-mountaincat&orientation=portrait",
    intro: "城市青年回到山中老家，与一只神秘白猫相伴，在四季流转中重新找回生活的温度。",
    popular: 4,
    updateInfo: "完结",
  },
  {
    id: "sword-river",
    title: "剑与江湖",
    author: "顾长风",
    genre: "武侠",
    tags: ["武侠", "江湖", "热血"],
    rating: 9.1,
    ratingCount: 20110,
    status: "连载中",
    chapters: "268话",
    cover: "https://readdy.ai/api/search-image?query=A%20majestic%20anime%20manga%20cover%20of%20a%20swordsman%20in%20flowing%20robes%20on%20a%20cliff%20above%20a%20misty%20river%2C%20warm%20golden%20sunset%20lighting%2C%20ink%20wash%20and%20vibrant%20color%20mix%2C%20heroic%20pose%2C%20clean%20dramatic%20composition&width=400&height=560&seq=manga-cover-swordriver&orientation=portrait",
    intro: "江湖纷争再起，无名剑客携一柄断剑入世，只为查清当年灭门之案的真相。刀光剑影，快意恩仇。",
    popular: 5,
    updateInfo: "5天前更新",
  },
  {
    id: "machine-city",
    title: "机械城追梦人",
    author: "齿轮",
    genre: "科幻",
    tags: ["赛博朋克", "青春", "梦想"],
    rating: 8.9,
    ratingCount: 6540,
    status: "连载中",
    chapters: "74话",
    cover: "https://readdy.ai/api/search-image?query=A%20neon%20cyberpunk%20anime%20manga%20cover%20of%20a%20young%20inventor%20with%20a%20robot%20companion%20in%20a%20futuristic%20city%2C%20warm%20orange%20and%20magenta%20neon%20glow%2C%20urban%20vibrancy%2C%20dynamic%20illustration%20composition&width=400&height=560&seq=manga-cover-machinecity&orientation=portrait",
    intro: "在机械改造泛滥的巨型都市里，心怀机械梦的少年少女们，用双手一点点拼凑出属于自己的未来。",
    popular: 6,
    updateInfo: "4天前更新",
  },
  {
    id: "flower-lane",
    title: "花开旧巷",
    author: "南星",
    genre: "恋爱",
    tags: ["青春", "恋爱", "校园"],
    rating: 9.3,
    ratingCount: 11290,
    status: "连载中",
    chapters: "103话",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20anime%20manga%20cover%20of%20two%20teens%20walking%20through%20a%20blossom%20lined%20old%20street%20under%20spring%20light%2C%20soft%20peach%20and%20cream%20palette%2C%20dreamy%20warm%20atmosphere%2C%20gentle%20clean%20illustration&width=400&height=560&seq=manga-cover-flowerlane&orientation=portrait",
    intro: "两条在旧巷中交错的生命线，因为一场樱花雨而相遇。关于暗恋、成长与告白的青春恋爱物语。",
    popular: 7,
    updateInfo: "2天前更新",
  },
  {
    id: "night-guard",
    title: "暗夜守卫",
    author: "夜枭",
    genre: "悬疑",
    tags: ["悬疑", "推理", "都市"],
    rating: 9.0,
    ratingCount: 8970,
    status: "连载中",
    chapters: "121话",
    cover: "https://readdy.ai/api/search-image?query=A%20moody%20anime%20manga%20cover%20of%20a%20detective%20in%20a%20long%20coat%20standing%20in%20a%20rainy%20night%20alley%2C%20warm%20lantern%20and%20amber%20lighting%20against%20dark%20blue%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20composition&width=400&height=560&seq=manga-cover-nightguard&orientation=portrait",
    intro: "每当夜色降临，城市里不为人知的案件便悄然发生。一名只于暗夜出动的守卫，追查着尘封的真相。",
    popular: 8,
    updateInfo: "6天前更新",
  },
  {
    id: "office-escape",
    title: "元气社畜自救指南",
    author: "咸鱼翻身",
    genre: "搞笑",
    tags: ["职场", "搞笑", "日常"],
    rating: 9.5,
    ratingCount: 15680,
    status: "连载中",
    chapters: "96话",
    cover: "https://readdy.ai/api/search-image?query=A%20humorous%20anime%20manga%20cover%20of%20a%20cheerful%20office%20worker%20giving%20a%20thumbs%20up%20with%20funny%20stickers%20around%2C%20bright%20warm%20orange%20and%20cream%20cartoon%20style%2C%20playful%20light%20composition&width=400&height=560&seq=manga-cover-officeescape&orientation=portrait",
    intro: "上班族的爆笑日常观察，在吐槽与自愈之间，找到属于打工人的快乐生存法则。",
    popular: 9,
    updateInfo: "1天前更新",
  },
  {
    id: "sea-lighthouse",
    title: "海雾灯塔",
    author: "岛田汐",
    genre: "奇幻",
    tags: ["奇幻", "治愈", "冒险"],
    rating: 9.3,
    ratingCount: 5430,
    status: "连载中",
    chapters: "67话",
    cover: "https://readdy.ai/api/search-image?query=A%20whimsical%20anime%20manga%20cover%20of%20a%20lighthouse%20keeper%20girl%20with%20glowing%20sea%20creatures%20in%20a%20misty%20ocean%2C%20warm%20amber%20beacon%20light%20and%20soft%20coral%20tones%2C%20magical%20cozy%20atmosphere%2C%20clean%20illustration&width=400&height=560&seq=manga-cover-sealighthouse&orientation=portrait",
    intro: "孤岛灯塔守护着通往幻想之海的门扉，少女阿澈在此遇见一群会说话的海洋生灵，展开奇妙的冒险。",
    popular: 10,
    updateInfo: "3天前更新",
  },
  {
    id: "brawl-academy",
    title: "乱斗高校",
    author: "炸鸡",
    genre: "热血",
    tags: ["校园", "格斗", "热血"],
    rating: 8.8,
    ratingCount: 7310,
    status: "连载中",
    chapters: "158话",
    cover: "https://readdy.ai/api/search-image?query=A%20high%20energy%20anime%20manga%20cover%20of%20a%20group%20of%20fist%20bumping%20students%20in%20a%20school%20courtyard%2C%20vibrant%20warm%20orange%20and%20red%20action%20burst%2C%20dynamic%20battle%20energy%2C%20bold%20clean%20composition&width=400&height=560&seq=manga-cover-brawlacademy&orientation=portrait",
    intro: "全校最乱的高中，聚集了一群不服输的少年。从地下擂台到校际大赛，热血青春就此开打。",
    popular: 11,
    updateInfo: "7天前更新",
  },
  {
    id: "time-traveler",
    title: "时空旅人",
    author: "尘光",
    genre: "奇幻",
    tags: ["穿越", "冒险", "史诗"],
    rating: 9.0,
    ratingCount: 8120,
    status: "连载中",
    chapters: "143话",
    cover: "https://readdy.ai/api/search-image?query=A%20epic%20anime%20manga%20cover%20of%20a%20traveler%20stepping%20through%20a%20portal%20of%20clockwork%20and%20starlight%2C%20warm%20gold%20and%20amber%20tones%20with%20deep%20brown%20shadows%2C%20grand%20fantasy%20composition&width=400&height=560&seq=manga-cover-timetraveler&orientation=portrait",
    intro: "一枚能拨动时间的怀表，将普通高中生带进跨越千年的宏大历史洪流。他能否改变既定的命运？",
    popular: 12,
    updateInfo: "5天前更新",
  },
];

export interface BookList {
  id: string;
  title: string;
  subtitle: string;
  count: number;
  color: string;
  desc: string;
}

export const bookLists: BookList[] = [
  {
    id: "bl-warm",
    title: "深夜治愈系书单",
    subtitle: "适合睡前慢慢看",
    count: 18,
    color: "primary",
    desc: "收录《云端食堂》《山雾里的猫》等暖心日常作品，治愈你一整天。",
  },
  {
    id: "bl-adventure",
    title: "热血冒险大长篇",
    subtitle: "一口气追到天亮",
    count: 25,
    color: "accent",
    desc: "从《星轨之下》到《时空旅人》，都是让人停不下来的冒险巨作。",
  },
  {
    id: "bl-mystery",
    title: "悬疑烧脑清单",
    subtitle: "看完烧脑一整晚",
    count: 12,
    color: "secondary",
    desc: "《暗夜守卫》领衔，推理、反转、细思极恐的悬疑佳作都在这里。",
  },
  {
    id: "bl-sweet",
    title: "少女心恋爱特辑",
    subtitle: "糖分超标预警",
    count: 15,
    color: "primary",
    desc: "《花开旧巷》等青春恋爱作品，带你重温怦然心动的瞬间。",
  },
];

export interface Topic {
  id: string;
  title: string;
  group: string;
  replies: number;
  views: number;
  hot: boolean;
  summary: string;
  author: string;
  time: string;
}

export const topics: Topic[] = [
  {
    id: "t1",
    title: "2026 年最值得追的 10 部新番漫画，你看过几部？",
    group: "新番安利",
    replies: 326,
    views: 12800,
    hot: true,
    summary: "整理了近半年口碑和热度双高的新作，附详细追读建议，欢迎补充你的私藏。",
    author: "追更狂魔",
    time: "2小时前",
  },
  {
    id: "t2",
    title: "《星轨之下》最新话战力分析，这波伏笔埋了三年！",
    group: "剧情分析",
    replies: 198,
    views: 8900,
    hot: true,
    summary: "结合前几卷设定逐帧分析最新话，大胆预测后续走向，含大量剧透慎入。",
    author: "剧情显微镜",
    time: "5小时前",
  },
  {
    id: "t3",
    title: "求推荐：像《山雾里的猫》一样治愈的作品",
    group: "求书求助",
    replies: 87,
    views: 3200,
    hot: false,
    summary: "最近迷上治愈系，想找同类型慢节奏、温馨日常的作品，在线等推荐。",
    author: "小确幸",
    time: "1天前",
  },
  {
    id: "t4",
    title: "《剑与江湖》结局你满意吗？来聊聊你的看法",
    group: "完结复盘",
    replies: 254,
    views: 10100,
    hot: true,
    summary: "大结局已出，有人拍手叫好有人意难平，理性讨论一下这个结局的处理。",
    author: "江湖过客",
    time: "3天前",
  },
  {
    id: "t5",
    title: "漫画评分到底怎么评才公平？聊聊各站的评分体系",
    group: "站务反馈",
    replies: 64,
    views: 2400,
    hot: false,
    summary: "评分打一星和五星的标准是什么？希望大家理性讨论，共建好氛围。",
    author: "评分观察员",
    time: "2天前",
  },
];